const getChartDefultOption = ({id, categories, distributed = false, customColors, columnWidth = "70%"}) => {
  const colors = customColors || [
    'var(--color-chart-4)',
    'var(--color-chart-3)',
    'var(--color-chart-2)',
    'var(--color-chart-1)',
    'var(--color-chart-0)',
  ]
  return {
    colors,
    chart: {
      id,
      type: "bar",
      height: 160,
      stacked: true,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
    legend: {
      show: false,
    },
    grid: {
      show: false,
    },
    yaxis: {
      show: false,
    },
    dataLabels: {
      enabled: true,
      // enabledOnSeries: false,
    },
    plotOptions: {
      bar: {
        
        columnWidth ,
        distributed,
        horizontal: false,
        borderRadius: 6,
        dataLabels: {
          total: {
            
            enabled: false,
            style: {
              fontSize: "10px",
              fontWeight: 700,
            },
          },
        },
      },
    },
    xaxis: {
      type: "string",
      categories,
      //   grid: {
      //     showLines: false, // Set to false to hide x-axis gridlines
      //   },
      labels: {
        style: {
          colors: ["var(--color-active)"],
          fontSize: '10px',
          fontWeight: "700"
        }
      },
      axisBorder: {
        show: true,
        color: "#78909C",
        height: 2,
        width: "100%",
        offsetX: 0,
        offsetY: 0,
      },
      axisTicks: {
        show: false,
      },
    },

    // tooltip: {
    //   custom: function({series, seriesIndex, dataPointIndex, w}) {
    //     const title = w.globals.initialSeries[seriesIndex].title
    //     const name = w.globals.initialSeries[seriesIndex].name
        
    //     return  title ?? name
    //   }
    // }
  };
};

export default getChartDefultOption;
